import { Observable } from 'rxjs';
import { inject, provideAppInitializer } from '@angular/core';
import { PromotionFeatureFlagsService } from './promotion-feature-flags.service';

function initializePromotionFeatureFlags(): () => Observable<any> {
  const promotionFeatureFlagsService = inject(PromotionFeatureFlagsService);
  return () => promotionFeatureFlagsService.getPromotionFeatureFlags();
}

export const providePromotionFeatureFlags = () =>
  provideAppInitializer(() => {
    const initializerFn = initializePromotionFeatureFlags();
    return initializerFn();
  });
